import type { ComponentType } from 'react';
import DashboardLink from './DashboardLink';
import LifeCycleLine from './LifeCycleLine';
import Sparkline from './Sparkline';
import MetricTile from './MetricTile';
import AssistantVisualFrame from './AssistantVisualFrame';
import type { CardModel, VisualFrameProps } from '../types';

const InlineCard = ({
    breadcrumb,
    title,
    link,
    lifeCycle,
    timeSeries,
    tiles,
    Frame = AssistantVisualFrame,
}: CardModel & { Frame?: ComponentType<VisualFrameProps> }) => (
    <Frame breadcrumb={breadcrumb}>
        <div className="bg-card border border-border rounded-xl shadow-xs p-4 flex flex-col gap-4">
            <div className="flex flex-col gap-2">
                <div className="flex min-h-8 items-center justify-between gap-2">
                    <div className="min-w-0 text-base font-semibold text-card-foreground truncate capitalize">
                        {title}
                    </div>
                    <DashboardLink link={link} label="View page" />
                </div>
                <LifeCycleLine stage={lifeCycle} />
            </div>
            <Sparkline timeSeries={timeSeries} />
            <div className="grid grid-cols-2 gap-2">
                {tiles.map((tile, i) => (
                    <MetricTile key={i} {...tile} />
                ))}
            </div>
        </div>
    </Frame>
);

export default InlineCard;
